import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-20 px-6 bg-gray-900 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center"
      >
        <h2 className="text-3xl font-bold mb-4">About Munorva</h2>
        <p className="mb-6">
          Munorva Private Limited Technology is an innovation-driven technology
          company focused on building intelligent systems that combine AI, IoT,
          and modern software architecture. Our mission is to create scalable
          digital ecosystems that empower communities, businesses, and
          institutions.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
          <div>
            <h3 className="font-semibold text-xl mb-2">Vision</h3>
            <p>
              To become a global leader in intelligent communication and AI
              infrastructure.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-xl mb-2">Mission</h3>
            <p>
              Deliver innovative, scalable, and reliable technology solutions
              for the future.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-xl mb-2">Our Approach</h3>
            <p>
              Innovation-driven, user-centric, and built on cutting-edge
              research.
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;
